import { useContext, useEffect, useState } from "react";
import { history } from "../../utils/variables";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser } from "../../redux/actions";
import { toast } from "../../utils/functions";
import { useTranslation } from "react-i18next";
import { TitleContext } from "../../App";

export default function Error() {
    const { t } = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();
    const[showError,setShowError] = useState(false)
    // const {setTitle} = useContext(TitleContext)
    // useEffect(()=>{
    //     setTitle('')
    // },[])
    useEffect(()=>{
        if(location.state?.response?.status === 401){
            dispatch(setUser({}));
            history.push('/login');
            toast(t('Please enter again'), 'error');
        }else{
            if(!location.state?.response?.data){
                history.push('/');
            }
            setShowError(true)
        }
    },[])
    function closeModal(){
        history.replace("/");
    }
    return(
        <>
        {showError ?
        <>
            <div className='err-modal'>
                <div className="header-icon"><i className="fas fa-exclamation-triangle"/></div>
                <div className='error-msg'>
                    <p>{location.state?.response?.data?.msg}</p>
                    <p>{t('To solve this problem call hamrah bimeh')}</p>
                    </div>
                    <div className="contact-box mb10">
                        <a 
                            href='tel:09966935907' 
                            className='btn btn-circle btn-blue btn-block mt10 contact-btn'
                            //style={{ width: 'auto' }}
                            >
                            <i className='fas fa-phone ml10' />
                             {t('Call hamrah bimeh')}
                            
                        </a>
                    </div>
                <button className="btn btn-block btn-circle btn-red" onClick={closeModal}>{t('Get it')}</button>
                </div>
                <div className="flex1"></div>
                </>
                :
                <div className="err-modal">
                    <div className='error-msg'>
                        <p>خطایی رخ داده است لطفا دوباره وارد شوید</p>
                        <button className="btn btn-block btn-circle btn-red mt20" onClick={()=>history.push('/login')}>بازگشت به صفحه ورود</button>
                    </div>
                </div>
        }
        </>
    )
}